import { LucideIcon } from 'lucide-react';

import { Badge } from 'components/Badge';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Tooltip';
import { Typography } from 'components/typography';

export interface MetadataHintBadgeProps {
  label: string;
  tooltipDescription: string;
  icon: LucideIcon;
}

/** Non-interactive metadata badge with tooltip context. */
export function MetadataHintBadge({
  label,
  tooltipDescription,
  icon: Icon,
}: MetadataHintBadgeProps) {
  return (
    <Tooltip delayDuration={10}>
      <TooltipTrigger
        asChild
        onClick={(e: React.MouseEvent<HTMLElement>) => e.stopPropagation()}
      >
        <Badge
          variant='secondary'
          className='inline-flex items-center justify-center gap-1 text-[11px] px-1.5 py-0.5 rounded border text-neutral-600 bg-neutral-100 border-neutral-300 font-normal leading-none'
        >
          <Icon className='h-3 w-3 shrink-0 self-center' />
          <span className='truncate leading-none'>{label}</span>
        </Badge>
      </TooltipTrigger>
      <TooltipContent
        className='bg-neutral-50 border-neutral-200'
        side='bottom'
      >
        <Typography variant='body-xs'>{tooltipDescription}</Typography>
      </TooltipContent>
    </Tooltip>
  );
}
